/* global Config */

import io from 'socket.io-client';

const socket = global.Config && Config.socket &&
    io(Config.socket.serverUrl, {
        autoConnect: false,
        transports: ['websocket'], // we don't support archaic browsers, so no pulling
    });

export default socket;
